import common from "./common.json";

export const hk = {
  common,
};
